import { useEffect } from 'react';
import { useThrottle } from '@wix/da-hooks/pkg/useThrottle';
/** popper-free, very basic alignment for when all the fancy stuff is
 *  overkill and performance matters */ export function useBasicPopoverPositioning(contentNode, popoverNode, { placement = 'right', secondaryPlacement = 'middle', enabled = true, updatePositionOnScroll = true, throttleDelay = 100 } = {}) {
    const positionTooltip = useThrottle(()=>{
        if (!contentNode || !popoverNode) {
            return;
        }
        const contentRect = contentNode.getBoundingClientRect();
        const tooltipRect = popoverNode.getBoundingClientRect();
        popoverNode.style.position = 'fixed';
        popoverNode.style.willChange = 'transform';
        // TODO: add support for other placements
        switch(placement){
            case 'right':
            default:
                popoverNode.style.top = '0';
                popoverNode.style.left = `${contentRect.right}px`;
                switch(secondaryPlacement){
                    case 'start':
                        popoverNode.style.transform = `translateY(${contentRect.y - contentRect.height / 2}px)`;
                        break;
                    case 'end':
                        popoverNode.style.transform = `translateY(${contentRect.y + contentRect.height - tooltipRect.height}px)`;
                        break;
                    case 'middle':
                    default:
                        popoverNode.style.transform = `translateY(${contentRect.y + contentRect.height / 2 - tooltipRect.height / 2}px)`;
                }
        }
    }, [
        contentNode,
        popoverNode,
        placement
    ], throttleDelay, {
        leading: true,
        trailing: true
    });
    useEffect(()=>{
        if (!enabled) {
            return;
        }
        positionTooltip();
        if (updatePositionOnScroll) {
            window.addEventListener('scroll', positionTooltip);
            return ()=>{
                window.removeEventListener('scroll', positionTooltip);
            };
        }
    }, [
        enabled,
        positionTooltip,
        updatePositionOnScroll
    ]);
    return {
        positionTooltip
    };
}
